<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableMessageQueueDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="detail">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            v-hasPermission="['monitor:messageQueueMonitor:delete']"
            @click="MessageQueueDelmodal = true"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
        <Button
          type="info"
          size="small"
          v-hasPermission="['monitor:messageQueueMonitor:detail']"
          @click="rowClick(row)"
          >{{ $t("alarms.common.details") }}</Button
        >
      </template>
    </Table>
    <!-- 删除队列模式框 -->
    <Modal v-model="MessageQueueDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ brokerNames }}
          {{ $t("alarms.common.what") }}？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeMessageQueue()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableMessageQueueVue = {};
export default {
  name: "TableMessageQueue",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      MessageQueueDelmodal: false,
      isDisable: false,
      modal_loading: false,
      brokerNames: "",
      val: "",
      region: "",
      columns: [
        {
          title: this.$t("alarms.queue.name"),
          key: "brokerName"
        },
        {
          title: this.$t("alarms.common.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.common.accountType"),
          key: "accountTypeName"
        },
        {
          title: this.$t("alarms.queue.brokerId"),
          key: "brokerId"
        },
        {
          title: this.$t("alarms.queue.brokerEngine"),
          key: "engineType"
        },
        {
          title: this.$t("alarms.common.status"),
          key: "stateName"
        },
        {
          title: this.$t("alarms.queue.region"),
          key: "region"
        },
        {
          title: this.$t("common.operation"),
          slot: "detail"
        }
      ],
      tableMessageQueueDate: []
    };
  },
  beforeCreate: function() {
    tableMessageQueueVue = this;
  },
  mounted: function() {
    // tableMessageQueueVue.getMessageQueueData();
  },
  created() {
    eventBus.$on("brokerSummaryIdSearchName", function(val) {
      tableMessageQueueVue.brokerSummaryIdSearchName = val;
    });
    eventBus.$on("companyId", function(region) {
      tableMessageQueueVue.companyId = region;
    });
  },
  methods: {
    showAll: function() {
      tableMessageQueueVue.getMessageQueueData();
    },
    // 分页显示数据
    /****************************************************/
    getMessageQueueData: function() {
      //列表分页
      this.$api.brokerSummary
        .brokerSummaryPage({
          brokerId: tableMessageQueueVue.brokerSummaryIdSearchName,
          companyId: tableMessageQueueVue.companyId,
          pageNum: this.current,
          pageSize: this.pageSize,
          monitorModule: 16
        })
        .then(res => {
          this.tableMessageQueueDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableMessageQueueVue.getMessageQueueData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableMessageQueueVue.getMessageQueueData();
    },
    // 销毁brokerSummaryIdSearchName
    beforeDestroy: function() {
      eventBus.$off("brokerSummaryIdSearchName");
    },
    // 销毁regionName
    beforeDestroy: function() {
      eventBus.$off("regionName");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.brokerNames = this.tableMessageQueueDate[index].brokerName;
    },
    removeMessageQueue: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.brokerSummary
        .deleteBrokerSummary("id", this.tableMessageQueueDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableMessageQueueVue.getMessageQueueData();
            this.isDisable = false;
            this.modal_loading = false;
            this.MessageQueueDelmodal = false;
            this.$Message.success(this.$t('common.deleteSuccess'));
          }, 1000);
        });
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/monitor/messageQueueDetail/",
        query: {
          id: row.id,
          accountId: row.accountId,
          brokerId: row.brokerId,
          region: row.region,
          accountTypeName: row.accountTypeName,
          accountName: row.accountName,
          name: row.brokerName
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/mq/TableMessageQueue.vue